'use client';

import { Loader2 } from 'lucide-react';

/**
 * The dashboard's full-surface loading spinner. Renders a spinner and nothing
 * else.
 *
 * It used to fire the client bootstrap (`useUpdatedData().updateData()`) from
 * its own effect, which made it the wrong shape for the ~24 places that reach
 * for it as an ordinary loading placeholder: a Suspense fallback, a
 * RequireSession fallback, a "session still settling" branch. Every one of
 * those mounts kicked off a full user + org + repositories bootstrap, and the
 * dedupe latch in `useUpdatedData` is nulled in its own `.finally()`, so it
 * only collapses concurrent calls and never repeat ones. Remounting the
 * placeholder therefore re-ran the whole chain.
 *
 * The bootstrap now belongs to `DashboardBootstrap` (app/(dashboard)/), which
 * runs once per layout mount for every dashboard route. Routes outside that
 * layout have no such sibling and do still need a spinner that starts the
 * bootstrap; they use `BootstrapSpinner`.
 */
const InitialSpinner = () => (
  <div className="flex items-center justify-center bg-ds-surface-white h-full rounded-tl-[15px] w-full">
    <Loader2
      className="h-10 w-10 animate-spin text-ds-text-default"
      aria-hidden
    />
  </div>
);

export default InitialSpinner;
